import React, { FC, useCallback } from 'react';
import Button, { ButtonGroup, LoadingButton } from '@atlaskit/button';
import { AuthenticatedUserProfile, UserRedirectionType } from '@atlassian/cssxp-typescommon';
import { useApprovalDeskPermissions, useConfirmationDialogContext } from '@css-xp/apd-common';
import { useApplicationContext } from '@css-xp/base/common-context';
import DecisionTableConfirmationModal from './modal/decision-table-confirmation-modal';

interface DecisionControlsProps {
  editMode: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  isLoading: boolean;
  ssamContainer?: string;
}

export const DecisionControls: FC<DecisionControlsProps> = ({
  onEdit,
  onSave,
  onCancel,
  editMode,
  isLoading,
  ssamContainer,
}) => {
  const { openModal, closeModal } = useConfirmationDialogContext();
  const { redirectionData } = useApplicationContext() as AuthenticatedUserProfile;
  const { isApprovalProcessRuleUpdateEnabled, hasTaskManagerWriteAccess } = useApprovalDeskPermissions();

  let ssamUrl = '';
  for (const item of redirectionData) {
    if (item?.name === UserRedirectionType.SSAM) {
      ssamUrl = item?.url;
      break;
    }
  }

  if (ssamUrl && ssamContainer) {
    ssamUrl = `${ssamUrl}/containers/${ssamContainer}`;
  }

  const handleEdit = useCallback(() => {
    openModal({
      modalContent: <DecisionTableConfirmationModal onEdit={onEdit} closeModal={closeModal} />,
    });
  }, [onEdit, closeModal]);

  return (
    <>
      {editMode ? (
        <ButtonGroup>
          <Button onClick={onCancel} className="header-action-btn">
            Discard changes
          </Button>
          <LoadingButton appearance="primary" onClick={onSave} isLoading={isLoading} className="header-action-btn">
            Save changes
          </LoadingButton>
        </ButtonGroup>
      ) : (
        <ButtonGroup>
          <Button href={ssamUrl} target="_blank" rel="noopener" className="header-action-btn">
            Group details
          </Button>
          {isApprovalProcessRuleUpdateEnabled && hasTaskManagerWriteAccess && (
            <Button onClick={handleEdit} className="header-action-btn">
              Edit table
            </Button>
          )}
        </ButtonGroup>
      )}
    </>
  );
};
